export const hasFieldError = meta => meta.touched && meta.error
